import { render, staticRenderFns } from "./HkiaraceEventCategoryDetail.vue?vue&type=template&id=52b9104c&scoped=true"
import script from "./HkiaraceEventCategoryDetail.vue?vue&type=script&lang=js"
export * from "./HkiaraceEventCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9104c",
  null
  
)

export default component.exports